{
  "alert.informative": "情報",
  "alert.negative": "否定",
  "alert.notice": "通知",
  "alert.positive": "肯定",
  "attachmentlist.nextAttachments": "次の添付ファイルを表示",
  "attachmentlist.previousAttachments": "前の添付ファイルを表示",
  "chat.newMessage": "新規メッセージ",
  "chat.scrollToBottom": "下部までスクロール",
  "messagefeedback.thumbDown": "無効な応答",
  "messagefeedback.thumbUp": "有効な応答",
  "promptfield.aiDisclaimer": "応答は AI を使用して生成されますが、情報が不正確である場合があります。使用する前に確認してください。",
  "promptfield.aiUserGuidlines": "AI ユーザーガイドライン",
  "promptfield.attachments": "添付ファイル",
  "promptfield.insertButton": "追加",
  "promptfield.label": "プロンプト",
  "promptfield.placeholder": "開始する準備は整いましたか？質問をしたり、アイデアを共有したり、タスクを追加したりします。",
  "promptfield.placeholder.small": "何でも質問",
  "promptfield.stopButton": "停止",
  "promptfield.submitButton": "送信",
  "promptfield.uploading": "アップロードしています",
  "responsestatus.loading": "読み込み中",
  "responsestatus.processing": "処理中...",
  "voicebutton.startListening": "記録を開始",
  "voicebutton.stopListening": "記録を停止"
}
